export const LOCALES = [
    {
        id: 'en',
        title: 'en'
    },
    {
        id: 'ru',
        title: 'ru',
    }
]